import { Col } from 'antd'
import React, { useContext } from 'react'
import { FormItem } from '../../../../../../components/UIComponents/FormStyles'
import { RuleContext } from '../../RulesCreationTable'
import { StyledRuleRow, StyledTextInput } from '../../style'
import { StyledBoldTextOne, TextContainer, TextLine } from '../CTCDrawers/style'

const RolesApplyingDrawer = () => {
  const {
    ruleForm,
    setState,
    state: { roleApplyPermit },
  } = useContext(RuleContext)

  const handleInputChange = e => {
    const currentMaxRoles = ruleForm.getFieldValue('roleApplyPermit')
    ruleForm.setFieldsValue({
      roleApplyPermit: {
        ...currentMaxRoles,
        roleCount: e.target.value,
        // isEnabled: e.target.value ? true : false,
      },
    })
    setState(prevState => ({
      ...prevState,
      roleApplyPermit: {
        ...prevState.roleApplyPermit,
        roleCount: e.target.value,
        // isEnabled: e.target.value ? true : false,
      },
    }))
  }
  return (
    <>
      <TextContainer>
        <TextLine>
          In this rule, enter the no. of roles a student should apply once the
          placement
        </TextLine>
        <TextLine>process is open if they are eligible.</TextLine>
      </TextContainer>

      <StyledRuleRow align={'middle'} pBottom={20} pTop={30}>
        <Col md={10}>
          <StyledBoldTextOne>Enter minimum no. of roles</StyledBoldTextOne>
        </Col>
        <Col>
          <FormItem
            name={['roleApplyPermit', 'roleCount']}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value == 0) {
                    return Promise.reject(
                      new Error('Please enter the minimum no of roles')
                    )
                  }
                  
                  if (value < 0) {
                    return Promise.reject(new Error('Negative values are not allowed'))
                  }
                  
                  return Promise.resolve()
                },
              }),
            ]}
          >
            <StyledTextInput
              type="number"
              placeholder="0"
              width="200px"
              height={'40px'}
              onChange={e => handleInputChange(e)}
              value={roleApplyPermit?.roleCount || 0}
            />
          </FormItem>
        </Col>
      </StyledRuleRow>

      <TextContainer>
        <TextLine>
          Failure to apply for the{' '}
          <b>{roleApplyPermit?.roleCount || 0} consecutive roles </b> will
          result in restrictions from
        </TextLine>
        <TextLine>
          further participation. To remain eligible, students must apply for the
          minimum
        </TextLine>
        <TextLine>
          required roles. Non-compliance will require approval for future
          applications.
        </TextLine>
      </TextContainer>
    </>
  )
}

export default RolesApplyingDrawer
